import { facturaPosVerPath, ROUTES } from '../config/routes';
import type { LoteMovimientoDto } from '../types/lotes-informes';

/** Resuelve la ruta de detalle del comprobante asociado a un movimiento de lote. */
export function resolveLoteMovimientoPath(m: LoteMovimientoDto): string | null {
  const id = m.nroIDFormulario;
  if (id == null || !Number.isFinite(Number(id)) || Number(id) <= 0) return null;

  const tipo = `${m.tipoDocumento || ''} ${m.tipoMov || ''}`.toUpperCase();
  const nroTipo = String(m.nroTipoFormulario ?? '').trim();
  const tercero = String(m.tipoCliente ?? '').trim().toUpperCase();

  if (
    tipo.includes('AJUSTE') ||
    tipo.includes('TRANSFERENCIA') ||
    nroTipo === '8' // tipificación frecuente de ajustes en inventario
  ) {
    return `/inventario/transferencias/${id}`;
  }

  if (tipo.includes('NOTA DE CREDITO') || tipo.includes('NOTA CRÉDITO') || /\bNC\b/.test(tipo)) {
    if (tercero === 'P' || tercero === 'PROV' || tercero === 'PROVEEDOR') {
      return `/compras/notas-credito/${id}`;
    }
    return ROUTES.ventas.notasCredito.ver(Number(id));
  }

  if (tipo.includes('NOTA DE DEBITO') || tipo.includes('NOTA DÉBITO') || /\bND\b/.test(tipo)) {
    return ROUTES.ventas.notasDebito.ver(Number(id));
  }

  if (tipo.includes('REMITO')) {
    if (tercero === 'P' || tercero === 'PROV' || tercero === 'PROVEEDOR' || tipo.includes('COMPRA')) {
      return `/compras/remitos/${id}`;
    }
    return `/ventas/remitos/${id}`;
  }

  if (tipo.includes('FACTURA') || tipo.includes('FC') || nroTipo === '12') {
    if (tercero === 'P' || tercero === 'PROV' || tercero === 'PROVEEDOR' || tipo.includes('COMPRA')) {
      return `/compras/facturas/${id}`;
    }
    return facturaPosVerPath(Number(id));
  }

  if (tipo.includes('ORDEN') && tipo.includes('COMPRA')) {
    return `/compras/ordenes/${id}`;
  }

  // Fallback: si hay formulario, intentar factura de venta (caso más frecuente en salidas)
  return facturaPosVerPath(Number(id));
}

export function labelLoteMovimientoDocumento(m: LoteMovimientoDto): string {
  if (m.nroDocumento?.trim()) return m.nroDocumento.trim();
  if (m.nroIDFormulario) return `#${m.nroIDFormulario}`;
  return '—';
}
